module.exports = __webpack_public_path__ + "img/step16_a_remove_tray_and_box.a73ec7fc.png";